<template lang="pug">
  .row.form-group
    .col-md-3
      label.form-label.form-label--center  {{ $t("components.time_slot.availability") }} {{ index + 1}}
    .col-md-4
      .form-icon-wrapper
        datepicker(ref="datepicker" wrapper-class="" input-class="form-control" type="text" placeholder="" language="fr" :disabled="state.disabled" v-model='availability.attributes.date' :monday-first="true")
        i.fal.fa-calendar(@click.prevent="$refs.datepicker.showCalendar()")
    .col-md-4
      v-select(:options="periodsTranslated" :disabled="disabled" v-model='selectedPeriod')

    .col-md-1
      /// REMOVE AVAILAIBILITY
      a(v-if="!disabled" @click.prevent="deleteAvailability" href="#" )
        h5
          span.fal.fa-times-circle.form-label--center

    input(type='hidden' :name="nameFor(availability, 'id')" :value="availability.attributes.id")
    input(type='hidden' :name="nameFor(availability, 'date')" :value="availability.attributes.date")
    input(type='hidden' :name="nameFor(availability, 'period')" :value="availability.attributes.period")
    input(type='hidden' :name="nameFor(availability, '_destroy')" :value="availability.attributes._destroy")

</template>

<script>
  import Datepicker from 'vuejs-datepicker'
  import vSelect from 'vue-select'
  import I18n from 'vue-i18n'

  var yesterday = new Date(Date.now() - 8640000)

  export default {
    components: {
      Datepicker,
      vSelect,
      I18n
    },
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      periods: Array,
      availability: {
        type: Object,
        required: true
      },
      index: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        state: {
          disabled: {
            to: yesterday // Disable all dates up to today's date
          }
        },
        selectedPeriod: {
          label: this.$t('components.time_slot.periods.' + this.availability.attributes.period),
          value: this.availability.attributes.period
        }
      }
    },
    computed: {
      periodsTranslated () {
        var translatedPeriods = []
        for (var key in this.periods) {
          translatedPeriods.push(
            {
              label: this.$t('components.time_slot.periods.' + this.periods[key]),
              value: this.periods[key]
            }
          )
        }
        return translatedPeriods
      }
    },
    watch: {
      selectedPeriod () {
        this.availability.attributes.period = this.selectedPeriod.value
      }
    },
    methods: {
      deleteAvailability () {
        this.$emit("delete", this.availability)
      },

      nameFor (availability, attribute) {
        let id = -1 - this.index

        if (availability.id) {
          id = availability.id
        }

        return "appointment_request[time_slots_attributes][" + id + "][" + attribute + "]"
      }
    }
  }
</script>
